/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSCheckBox from "components/Forms/TSCheckBox";
import { Collapse, Modal, ModalBody } from "reactstrap";
import loading from "assets/img/loading-load.gif";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";


const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }, { id: 6, forecolor: '#6D4C41' }]

const useStyles = makeStyles(styles);


const DisabledDay = (props) => {
    var moment = require('moment');
    require('moment/locale/th');
    const [leaveAll, setLeaveAll] = useState([]);
    const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD"));
    const [isLoading, setIsLoading] = useState(false);
    const [DisableKey, setDisableKey] = useState(0);
    const [Note, setNote] = useState("");
    const [Name, setName] = useState("");
    const [DisabledDatetime, setDisabledDatetime] = useState("");
    const [IsDisabled, setIsDisabled] = useState(false);
    const [bookingType, setBookingType] = useState(0);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");

    const [isOpen, setIsOpen] = useState(false);
    // const [isShowCalendar, setIsShowCalendar] = useState(false);

    // ใช้ useRef แทน createRef ใน Functional Component
    const calendarRef = useRef(null);

    // ฟังก์ชันที่จะทำงานตอนกดชื่อวัน (ห่อด้วย useCallback)
    const handleDayHeaderClick = useCallback((dayName) => {
        alert(`คุณกดหัววัน: ${dayName}`);
        // 👇 ทำอย่างอื่นต่อได้ เช่น
        // navigateToDayView(dayName);
        // setSelectedDay(dayName);
    }, []);

    useEffect(() => {
        // ฟังก์ชันผูก event หลัง FullCalendar render แล้ว
        const bindDayHeaderClicks = () => {
            const headerCells = document.querySelectorAll(".fc-col-header-cell");
            headerCells.forEach((cell) => {
                const dayName = cell.innerText.trim(); // เช่น “จันทร์”, “Tue”
                cell.style.cursor = "pointer";
                cell.onclick = () => handleDayHeaderClick(dayName);
            });
        };

        // รันครั้งแรก
        bindDayHeaderClicks();

        // และรันใหม่ทุกครั้งที่เปลี่ยนเดือน/สัปดาห์/view
        const calendarApi = calendarRef.current?.getApi();
        if (calendarApi) {
            calendarApi.on("datesSet", bindDayHeaderClicks);
        }

        // cleanup event
        return () => {
            const headerCells = document.querySelectorAll(".fc-col-header-cell");
            headerCells.forEach((cell) => (cell.onclick = null));
        };
    }, [handleDayHeaderClick]); // เพิ่ม handleDayHeaderClick ใน dependency

    const arrBookingType = [
        { value: "booking", label: "จองคิวในเวลา" },
        { value: "smc", label: "จองคิว SMC" },
        { value: "tele", label: "Tele พบแพทย์" },
        { value: "teleremed", label: "Tele ยาเดิม" }
    ];

    // ห่อ getMeeting ด้วย useCallback เพื่อแก้ปัญหา dependency
    const getMeeting = useCallback((e) => {
        let month = e.getUTCMonth() + 1; //months from 1-12
        let year = e.getUTCFullYear();

        axios.get('/api/disabledday/' + year + "/" + month + "/" + bookingType)
            .then(
                result => {
                    const temp = [];
                    var data = result.data.data;
                    if (data.length >= 0) {
                        for (let i = 0; i < data.length; i++) {
                            var newObj = {
                                name: data[i].name
                                , disabledDatetime: data[i].disabledDatetime
                                , disabledDatetime2: data[i].disabledDatetime
                                , disableKey: data[i].disableKey.toString()
                                , note: data[i].note
                                , isDisabled: data[i].isDisabled
                                , disableType: data[i].disableType
                            }
                            temp.push(newObj);
                        }
                    }
                    var json = JSON.parse(JSON.stringify(temp).split('"name":').join('"title":').split('"disabledDatetime":').join('"start":')
                        .split('"disabledDatetime2":').join('"end":').split('"disableKey":').join('"id":'));
                    if (json.length >= 0) {
                        setLeaveAll(json);
                    }

                },
                error => { alert(error); }
            );
    }, [bookingType]); // เพิ่ม bookingType ใน dependency เพราะมีการใช้ใน axios

    useEffect(() => {
        // แก้ไข: != เป็น !==
        if (DefaultDate !== null && DefaultDate !== '') {
            // เพิ่มการเช็ค calendarRef.current ก่อนใช้งาน
            if (calendarRef.current) {
                let calendarApi = calendarRef.current.getApi();
                calendarApi.gotoDate(DefaultDate);
            }
        }
    }, [DefaultDate]); // เพิ่ม calendarRef ใน dependency ถ้าจำเป็น แต่ปกติ ref ไม่ต้องใส่


    useEffect(() => {
        if (calendarRef.current) {
            let calendarApi = calendarRef.current.getApi();
            getMeeting(calendarApi.getDate())
        }
    }, [getMeeting]) // เพิ่ม getMeeting ใน dependency

    // useEffect ตัวนี้ซ้ำซ้อนกับด้านบน เพราะ getMeeting มี bookingType เป็น dependency แล้ว
    // แต่ถ้าต้องการให้ทำงานเมื่อ bookingType เปลี่ยนจริงๆ ก็สามารถรวม logic ได้
    // useEffect(() => {
    //     if(calendarRef.current){
    //         let calendarApi = calendarRef.current.getApi();
    //         getMeeting(calendarApi.getDate())
    //     }
    //   },[bookingType, getMeeting]); 


    const handleConfirm = evt => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        var DisabledDay = {
            disabledDatetime: DisabledDatetime,
            name: Name,
            disableType: bookingType,
            note: Note,
            isDisabled: IsDisabled,
        }

        // แก้ไข: != เป็น !==
        if (DisableKey !== 0 && DisableKey !== '' && DisableKey !== null) {
            axios.put('/api/disabledday/' + DisableKey, DisabledDay)
                .then(
                    result => {
                        // แก้ไข: == เป็น ===
                        if (result.data.result === 200) {
                            setDefaultDate(result.data.data.disabledDatetime);
                            setIcon("far fa-question-circle");
                            setModal(false)
                            setModal2(true)
                            const date = new Date(result.data.data.disabledDatetime);
                            getMeeting(date);
                        }
                        else {
                            setIcon("far fa-question-circle");
                            setModal(false)
                            setErrMsg(result.data.msg)
                            setModalError(true)
                        }

                    },
                    error => { console.log(error); }
                );
        } else {
            axios.post('/api/disabledday', DisabledDay)
                .then(
                    result => {
                        // แก้ไข: == เป็น ===
                        if (result.data.result === 200) {
                            setDisableKey(result.data.data.disableKey);
                            setDefaultDate(result.data.data.disabledDatetime);
                            setIcon("far fa-question-circle");
                            setModal(false);
                            setModal2(true);
                            const date = new Date(result.data.data.disabledDatetime);
                            getMeeting(date);
                        } else {
                            setIcon("far fa-question-circle");
                            setModal(false);
                            setErrMsg(result.data.msg);
                            setModalError(true);
                        }

                    }, error => { console.log(error); }
                );
        }

    };


    const handleDateClick = (args) => {
        setDefaultDate(args.dateStr);
        setDisabledDatetime(args.dateStr)
        setDisableKey(0);
        setName("");
        //setENName("");
        setNote("");
        setIsDisabled(true);
    };

    const handleEventClick = (args) => {
        setDefaultDate(moment(args.event.start).format('YYYY-MM-DD'))
        setDisabledDatetime(moment(args.event.start).format('YYYY-MM-DD'))
        setDisableKey(args.event._def.publicId);
        setName(args.event._def.title);
        //setENName(args.event._def.extendedProps.enName === null ? " " : args.event._def.extendedProps.enName);
        setNote(args.event._def.extendedProps.note === null ? " " : args.event._def.extendedProps.note);
        setIsDisabled(args.event._def.extendedProps.isDisabled);
    };

    const handleSubmit = evt => {
        evt.preventDefault();
        var cntErr = 0;

        var errMsg = [];

        // แก้ไข: == เป็น ===
        if (DisabledDatetime === '') {
            cntErr += 1;
            errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุวันหยุด"}</li>);
        }

        // แก้ไข: == เป็น ===
        if (Name === '') {
            cntErr += 1;
            errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อวันหยุด"}</li>);
        }

        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {
            setModal(true);
        }
    };

    const classes = useStyles();
    return (

        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <Grid>
                                <Col xs={6} sm={6} md={3}>
                                    <h4 className={classes.cardTitleWhite}>จัดการวันปิดบริการ</h4>
                                </Col>
                                <Col xs={6} sm={6} md={6} style={{ color: 'black', textAlign: 'left' }}>
                                    {/* {isShowCalendar ? */}
                                    <TSSelect2 label="" options={arrBookingType} value={bookingType} onChange={e => setBookingType(e.value)} />
                                    {/* : <></>
                                } */}
                                </Col>
                            </Grid>
                        </CardHeader>
                        <CardBody>
                            <Grid>
                                {isLoading && (
                                    <>
                                        <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                                            <img style={{ width: "50%" }} src={loading} alt="..." />
                                        </Col>
                                    </>
                                )}
                                {!isLoading && (<>
                                    <Col xs={12} sm={12} md={6}>
                                        <div style={{ textAlign: 'center' }}>
                                            <Fullcalendar
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                ref={calendarRef}
                                                initialView={"dayGridMonth"}
                                                headerToolbar={{
                                                    start: "title", // will normally be on the left. if RTL, will be on the right
                                                    center: "",
                                                    end: "myCustomButton,myCustomButton2,myCustomButton3", // will normally be on the right. if RTL, will be on the left
                                                }}
                                                hiddenDays={[0]}
                                                height={"100vh"}
                                                dateClick={handleDateClick}
                                                events={leaveAll}
                                                droppable={true}
                                                rerenderDelay={10}
                                                eventDurationEditable={false}
                                                //editable={true}
                                                //eventClick={}
                                                eventClick={handleEventClick}
                                                customButtons={{
                                                    myCustomButton: {
                                                        text: 'today',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.today();
                                                            getMeeting(calendarApi.getDate());
                                                        }
                                                    },
                                                    myCustomButton2: {
                                                        text: '<',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.prev();
                                                            getMeeting(calendarApi.getDate());
                                                        }
                                                    },
                                                    myCustomButton3: {
                                                        text: '>',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.next();
                                                            getMeeting(calendarApi.getDate());
                                                        }
                                                    },
                                                }}
                                                locale={'th'}
                                                eventContent={renderEventContent}
                                                displayEventTime={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} style={{ marginTop: "58px", backgroundColor: "#F4F4F4" }}>
                                        <Grid>
                                            <Col xs={12} sm={12} md={12}>
                                                <TSText icon="fas fa-calendar-alt" label="วันที่" value={DisabledDatetime} disabled={true} />
                                            </Col>
                                            <Col xs={12} sm={12} md={12}>
                                                <TSText icon="fas fa-edit" label="ชื่อวันหยุด" value={Name} onChange={e => setName(e.target.value)} />
                                            </Col>
                                            <Col xs={12} sm={12} md={12}>
                                                <TSText icon="fas fa-edit" label="หมายเหตุ" value={Note} onChange={e => setNote(e.target.value)} />
                                            </Col>
                                            <Col xs={12} sm={12} md={12}>
                                                {/* แก้ไข: != เป็น !== */}
                                                {(IsDisabled) ? <span style={{ color: 'green' }} >เปิดการใช้งานอยู่ </span> : <span style={{ color: 'red' }}>ปิดการใช้งานไปแล้ว </span>}<TSCheckBox checked={IsDisabled} onChange={e => setIsDisabled(!IsDisabled)} />
                                            </Col>

                                            {/* แก้ไข: != เป็น !== */}
                                            {(DisableKey !== 0 && DisableKey !== '' && DisableKey !== null) ?
                                                <Col xs={12} sm={12} md={12} style={{ height: "48px" }}>
                                                    <Button color="warning" onClick={handleSubmit} fullWidth>
                                                        <i className={"fa fa-edit"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }} ></i>
                                                        <h4>แก้ไข</h4>
                                                    </Button>
                                                </Col>
                                                :
                                                <Col xs={12} sm={12} md={12} style={{ height: "48px" }}>
                                                    <Button color="info" onClick={handleSubmit} fullWidth>
                                                        <i className={"fa fa-save"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }} ></i>
                                                        <h4>บันทึก</h4>
                                                    </Button>
                                                </Col>
                                            }

                                        </Grid>
                                    </Col>

                                </>)
                                }
                            </Grid>

                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>

                            </Collapse>
                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>

                            {/* Success */}
                            <Modal toggle={() => setModal2(false)} isOpen={modal2}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={"fas fa-check"}
                                            style={{ color: "green", fontSize: "4em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        บันทึกข้อมูลสำเร็จ
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="info"
                                        type="button"
                                        onClick={() => setModal2(false)}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ตกลง</h4>
                                    </Button>

                                </div>
                            </Modal>

                            {/* Error */}
                            <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className="fa fa-times"
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                    <div>{errMsg}</div>
                                </ModalBody>
                                <div className="modal-footer justify-content-center">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalError(false)}
                                    >
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );


    function renderEventContent(eventInfo) {

        const _c = _color.find(c => c.id === 1);
        // แก้ไข: == เป็น ===
        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isDisabled === false) ? 'red' : _c.forecolor) : '#000000';

        // แก้ไข: == เป็น ===
        const strikeTxt = (eventInfo.event.extendedProps.isDisabled === false) ? 'line-through' : '';

        return (
            <>
                <div className="fc-event-time" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.timeText}</div>
                <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.event.title}</div>
            </>
        )
    }
}

export default DisabledDay;